const DE = {
  'de.legal_and_other_fees.accounting_fees': {
    EN: 'Accounting fees 🔺',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Buchhaltungskosten 🔺',
  },
  'de.compensation.directors_compensation.majority_shareholder': {
    EN: 'Director compensation 💵',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Geschäftsführergehälter 💵',
  },
  'de.compensation.directors_compensation.minority_shareholder': {
    EN: 'Director compensation 💵',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Geschäftsführergehälter 💵',
  },
  'de.training_and_documentation.documentation': {
    EN: 'Docs 📚',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Fortbildung 📚',
  },
  'de.travel.for_self_employed.drive_to_work': {
    EN: 'Drive to work 🚘',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Fahrt zur Arbeit 🚘',
  },
  'de.legal_and_other_fees.audit_and_closing_fees': {
    EN: 'Audit fees ⚖️',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Rechts- und Prüfungskosten ⚖️',
  },
  'de.interest_and_bank_charges.bank_charges': {
    EN: 'Bank & interests',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Bankgebühren & Zinsen',
  },
  'de.interest_and_bank_charges.interest': {
    EN: 'Bank & interests',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Bankgebühren & Zinsen',
  },
  'de.marketing.personal_gifts_high.professional': {
    EN: 'Business gifts 🎁',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Geschenke 🎁',
  },
  'de.food_and_drinks.bar_and_restaurants': {
    EN: 'Canteen & restaurant 🍝',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Bewirtungen 🍝',
  },
  'de.categories.leasing.car_lease': {
    EN: 'Car 🚗  - Leasing',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Auto 🚗 - Leasing',
  },
  'de.investments.purchase.car': {
    EN: 'Car 🚗  - Purchase',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Auto 🚗 - Erwerb',
  },
  'de.vehicle.purchase.car': {
    EN: 'Car 🚗  - Purchase',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Auto 🚗 - Erwerb',
  },
  'de.categories.leasing.leasing_computer': {
    EN: 'Computer - Leasing',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Computer - Leasing',
  },
  'de.investments.construction': {
    EN: 'Construction 🏔',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Bauwesen 🏔',
  },
  'de.categories.leasing.leasing_electric_car_or_e_bike': {
    EN: 'eCarBike - leasing',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'eAuto/eBike - Leasing',
  },
  'de.travel.for_employee.car_private_use': {
    EN: 'Employee 🧑 - Car private',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Beschäftigte 🧑 - Auto Privat',
  },
  'de.travel.for_employee.flights': {
    EN: 'Employee 🧑 - Flights',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Beschäftigte 🧑 - Flüge',
  },
  'de.travel.for_employee.hotels': {
    EN: 'Employee 🧑 - Hotels',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Beschäftigte 🧑 - Hotels',
  },
  'de.travel.for_employee.per_diem': {
    EN: 'Employee 🧑 - Perdiem',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Beschäftigte 🧑 - Per diem',
  },
  'de.travel.for_employee.rental': {
    EN: 'Employee 🧑 - Rental',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Beschäftigte 🧑 - Anmietung',
  },
  'de.taxes_and_insurance': {
    EN: 'Employee 🧑 - Taxes',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Beschäftigte 🧑 - Steuern',
  },
  'de.travel.for_employee.taxi.long_distance': {
    EN: 'Employee 🧑 - Taxi',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Beschäftigte 🧑 - Taxi',
  },
  'de.travel.for_employee.taxi.short_distance': {
    EN: 'Employee 🧑 - Taxi',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Beschäftigte 🧑 - Taxi',
  },
  'de.travel.for_employee.public_transport': {
    EN: 'Employee 🧑 - Transport',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Beschäftigte 🧑 - Transport',
  },
  'de.travel.for_employee.other_travel_fees': {
    EN: 'Employee 🧑 - Travel',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Beschäftigte 🧑 - Reise',
  },
  'de.taxes_and_insurance.for_self_employed.fines_for_late_payment': {
    EN: 'Fines 💰',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Strafzahlungen 💰',
  },
  'de.travel.for_self_employed.flights': {
    EN: 'Flights ✈️',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Flüge ✈️',
  },
  'de.technology.hardware': {
    EN: 'Hardware 🛠',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Hardware 💻',
  },
  'de.compensation.health_insurance': {
    EN: 'Heatlh insurance ☔️',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Krankenversicherung ☔️',
  },
  'de.taxes_and_insurance.for_self_employed.health_insurance': {
    EN: 'Heatlh insurance ☔️',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Krankenversicherung ☔️',
  },
  'de.technology.hosting': {
    EN: 'Hosting 🖥',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Hosting 🖥',
  },
  'de.travel.for_self_employed.hotels': {
    EN: 'Hotels 🏨',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Hotels 🏨',
  },
  'de.taxes_and_insurance.for_self_employed.income_tax': {
    EN: 'Income tax 💰',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Einkommenssteuer 💰',
  },
  'de.investments.installations': {
    EN: 'Installation 🏗',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Installationen 🏗',
  },
  'de.categories.leasing.installment_purchase': {
    EN: 'Installment purchase',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Ratenkauf',
  },
  'de.taxes_and_insurance.for_self_employed.business_insurances': {
    EN: 'Insurance ☔️',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Versicherung ☔️',
  },
  'de.investments.land': {
    EN: 'Land 🏔',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Grund & Boden 🏔',
  },
  'de.legal_and_other_fees.lawyer_fees_and_consulting': {
    EN: 'Legal fees ⚖️',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Rechtskosten ⚖️',
  },
  'de.categories.mailing.commissions': {
    EN: 'Mailing commission ✉️',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Verkaufsprovisionen 💸',
  },
  'de.categories.mailing.other_transport_fees': {
    EN: 'Mailing fees ✉️',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Versandgebühren ✉️',
  },
  'de.categories.mailing.transport_insurance': {
    EN: 'Mailing insurance ✉️',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Transportversicherung ✉️',
  },
  'de.categories.mailing.package': {
    EN: 'Mailing packages ✉️',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Verpackung ✉️',
  },
  'de.categories.mailing.stamps_postage': {
    EN: 'Mailing stamps ✉️',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Porto ✉️',
  },
  'de.technology.maintenance': {
    EN: 'Maintenance 🖥',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Wartung 🖥',
  },
  'de.marketing.marketing': {
    EN: 'Marketing 📢',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Marketing 📢',
  },
  'de.legal_and_other_fees.membership_fees': {
    EN: 'Membership fees ⚖️',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Mitgliedsbeiträge ⚖️',
  },
  'de.compensation.minijobber_fee': {
    EN: 'Minijob',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Minijobber Abgabe',
  },
  'de.categories.leasing.leasing_office_furniture': {
    EN: 'Office - leasing',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Büro - Leasing 📎',
  },
  'de.office_supplies': {
    EN: 'Office & admin fees 📎',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Bürobedarf 📎',
  },
  'de.workplace.cleaning': {
    EN: 'Office cleaning 🛋',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Büroreinigung 🛋',
  },
  'de.workplace.decoration': {
    EN: 'Office decoration 🛋',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Bürodekoration 🛋',
  },
  'de.workplace.renovation': {
    EN: 'Office renovation 🛋',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Büro-Renovierung🛋',
  },
  'de.investments.purchase.other': {
    EN: 'Other 🚚  - Purchase',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Sonstiges 🚚 - Erwerb',
  },
  'de.vehicle.purchase.other': {
    EN: 'Other 🚚  - Purchase',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Sonstiges 🚚 - Erwerb',
  },
  'de.compensation.other_personal_expenses': {
    EN: 'Other expenses 💵',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Sonstige Personalausgaben 💵',
  },
  'de.legal_and_other_fees.other_fees': {
    EN: 'Other fees ⚖️',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Sonstige Gebühren ⚖️',
  },
  'de.travel.for_self_employed.other_travel_fees': {
    EN: 'Other travel fees 🌄',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Sonstige Reisekosten 🌄',
  },
  'de.compensation.pension_plan': {
    EN: 'Pension 👵🏻',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Altersvorsorge 👵🏻',
  },
  'de.taxes_and_insurance.for_self_employed.pension_plan': {
    EN: 'Pension 👵🏻',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Altersvorsorge 👵🏻',
  },
  'de.travel.for_self_employed.per_diem': {
    EN: 'Perdiem',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Verpflegungsmehraufwand',
  },
  'de.travel.for_self_employed.car_private_use': {
    EN: 'Private car 🚘',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Geschäftliche Nutzung Privatwagen 🚘',
  },
  'de.marketing.personal_gifts_high.private': {
    EN: 'Private gifts 🎁',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Firmengeschenke 🎁',
  },
  'de.taxes_and_insurance.for_self_employed.private_insurances': {
    EN: 'Private insurance ☔️',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Private Versicherung ☔️',
  },
  'de.marketing.promotional_gifts': {
    EN: 'Promo gifts 🎁',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Werbegeschenke 🎁',
  },
  'de.taxes_and_insurance.property_tax': {
    EN: 'Property tax 💰',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Grundsteuer 💰',
  },
  'de.travel.for_self_employed.public_transport': {
    EN: 'Public transport 🚃',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Öffentlicher Verkehr 🚃',
  },
  'de.travel.for_self_employed.rental': {
    EN: 'Rental 🚘',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Mietwagen 🚘',
  },
  'de.marketing.personal_gifts_low': {
    EN: 'Small gifts 🎁',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Firmengeschenke 🎁',
  },
  'de.technology.software_license': {
    EN: 'Software 🖥',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Software 🖥',
  },
  'de.compensation.spousal_compensation': {
    EN: 'Spouse compensation 💵',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Ehegattengehalt 💵',
  },
  'de.subcontracting.displayName': {
    EN: 'Subcontractors 😏',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Unterauftragnehmer 😏',
  },
  'de.travel.for_self_employed.taxi.long_distance': {
    EN: 'Taxi 🚕',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Taxi 🚕',
  },
  'de.travel.for_self_employed.taxi.short_distance': {
    EN: 'Taxi 🚕',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Taxi 🚕',
  },
  'de.taxes_and_insurance.for_self_employed.trade_tax': {
    EN: 'Trade tax 💰',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Gewerbesteuer 💰',
  },
  'de.training_and_documentation.training': {
    EN: 'Trainings 📚',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Fortbildung 📚',
  },
  'de.investments.purchase.truck': {
    EN: 'Truck 🚚  - Purchase',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Lkw 🚚 - Kauf',
  },
  'de.vehicle.purchase.truck': {
    EN: 'Truck 🚚  - Purchase',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Lkw 🚚 - Kauf',
  },
  'de.taxes_and_insurance.for_self_employed.vat.previous_year': {
    EN: 'VAT previous year 💰',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Umsatzsteuer - Letztes Jahr💰',
  },
  'de.vehicle.fuel': {
    EN: 'Vehicle 🚗  - Fuel',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Fahrzeug 🚗  - Tanken',
  },
  'de.vehicle.insurance': {
    EN: 'Vehicle 🚗  - Insurance',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Fahrzeug 🚗  - Versicherung',
  },
  'de.vehicle.leasing': {
    EN: 'Vehicle 🚗  - Leasing',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Fahrzeug 🚗  - Leasing',
  },
  'de.vehicle.other': {
    EN: 'Vehicle 🚗  - Other',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Fahrzeug 🚗  - Sonstiges',
  },
  'de.vehicle.parking': {
    EN: 'Vehicle 🚗  - Parking',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Fahrzeug 🚗  - Parken',
  },
  'de.vehicle.rental': {
    EN: 'Vehicle 🚗  - Rental',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Fahrzeug 🚗  - Miete',
  },
  'de.vehicle.repair': {
    EN: 'Vehicle 🚗  - Repairs',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Fahrzeug 🚗  - Reparaturen',
  },
  'de.vehicle.road_and_registration_taxes': {
    EN: 'Vehicle 🚗  - Taxes',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Fahrzeug 🚗  - Steuern',
  },
  'de.compensation.wage_tax': {
    EN: 'Wage tax 💰',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Lohnsteuer 💰',
  },
  'de.compensation.wages': {
    EN: 'Wages 💵',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Löhne & Gehälter 💵',
  },
  'de.compensation.workplace_levy': {
    EN: 'Workplace levy',
    FR: 'Not translated',
    NL: 'Not translated',
    DE: 'Berufsgenossenschaft',
  },
};

export default DE;
